export default __webpack_public_path__ + "static/media/unacast-symbol-deep_sea_blue-rgb.b5bd610e.svg";